import React from 'react';

interface Props {
  loading: boolean;
  onClose: () => void;
}

const SystemPlanActions: React.FC<Props> = ({ loading, onClose }) => (
  <div className="mt-4 flex justify-end">
    <button
      onClick={onClose}
      disabled={loading}
      className="inline-flex items-center justify-center rounded-sm border border-stroke bg-white px-4 py-2 text-sm font-medium text-black shadow-sm transition hover:bg-gray-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-strokedark dark:bg-boxdark dark:text-white dark:hover:bg-meta-4"
    >
      Cerrar
    </button>
  </div>
);

export default SystemPlanActions;
